import { render, staticRenderFns } from "./CarouselMyOffer.vue?vue&type=template&id=3988dc55"
import script from "./CarouselMyOffer.vue?vue&type=script&lang=js"
export * from "./CarouselMyOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports